/* eslint-disable react/require-default-props */
/* eslint no-unused-expressions: "off" */
import { FormEventHandler } from 'react';
import { SubmitHandler, useForm, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TreeCompany } from '../../../../api/model';
import Modal from '../../../modules/Modal';

type Props = {
  companyIndex?: number;
  open: boolean;
  company?: TreeCompany | undefined;
  onClose: () => void;
  setValue: UseFormSetValue<{ companies: TreeCompany[] }>;
  getValues: UseFormGetValues<{ companies: TreeCompany[] }>;
  /* eslint @typescript-eslint/no-explicit-any: 0 */
  append?: (params: any) => void;
};
function CompanyModal({ company, companyIndex, open, onClose, setValue, getValues, append }: Props) {
  const {
    register,
    getValues: getModalValues,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<TreeCompany>({
    defaultValues: {
      company_name_ja: companyIndex !== undefined ? getValues(`companies.${companyIndex}.company_name_ja`) : '',
      company_name_en: companyIndex !== undefined ? getValues(`companies.${companyIndex}.company_name_en`) : '',
    },
  });

  const {
    t,
  } = useTranslation();

  // const { mutateAsync, isSuccess, error, isLoading } = usePostOrganizationsUpdate<AxiosError<ErrorInfo>, unknown>(
  //   options
  // );

  // const onSubmit: FormEventHandler<HTMLFormElement> = useCallback(
  //   (e) => {
  //     e.preventDefault();
  //     void handleSubmit(async (data: FieldValues) => {
  //       await setValue(`companies.${companyIndex}`, data);
  //       onClose();
  //     })();
  //   },
  //   [handleSubmit]
  // );

  const handleSubmitWithoutPropagation: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    void handleSubmit(onSubmit)();
  };
  const onSubmit: SubmitHandler<TreeCompany> = () => {
    const companyNameJa = getModalValues('company_name_ja') || '';
    const companyNameEn = getModalValues('company_name_en') || '';

    if (companyIndex !== undefined) {
      setValue(`companies.${companyIndex}.company_name_ja`, companyNameJa);
      setValue(`companies.${companyIndex}.company_name_en`, companyNameEn);
    } else {
      append &&
        append({
          company_id: null,
          company_name_ja: companyNameJa,
          company_name_en: companyNameEn,
          hidden: 0,
        });
    }
    handleClose();
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal active={open} additionalClassName="popupfr800" displayCloseButton onClose={handleClose}>
      <form onSubmit={handleSubmitWithoutPropagation}>
        <div className="popupfr pt30 popupfr644">
          <div>{company?.company_name_ja}</div>
          <div className="teamsep2">
            <div>
              <label htmlFor="company_name_ja">{t('会社名（日）')}</label>
              <input type="text" {...register('company_name_ja', { required: true })} />
              {errors.company_name_ja?.type === 'required' && (
                <p className="errormessage show">{t('会社名（日）は必須項目です')}</p>
              )}
            </div>
            <div>
              <label htmlFor="company_name_en">{t('会社名（英）')}</label>
              <input type="text" {...register('company_name_en', { required: true })} />
              {errors.company_name_en?.type === 'required' && (
                <p className="errormessage show">{t('会社名（英）は必須項目です')}</p>
              )}
            </div>
          </div>
          <div className="btnfr btnfr2 mb0">
            <div>
              <span className="btn2 btnbg-g mr10">
                <span className="modal-close2" onClick={handleClose}>
                {t('キャンセル')}
                </span>
              </span>
              <span>
                <input type="submit" value={t('更新').toString()} className="btn1 lsp1" />
              </span>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
export { CompanyModal };